<template>
  <div class="left-content">
    <div class="title">选择需要的组合</div>
    <div class="line"></div>
    <div>
      <div class="item item-1" :class="{ active: !subHasActive }" @click="changeActive(undefined)">
        全部REITs
      </div>
      <div
        class="el-cols-wrap"
        :class="{
          active: subHasActive,
        }">
        <el-collapse v-model="activeNames">
          <el-collapse-item title="自选组合" name="自选组合">
            <div
              :title="item.name"
              class="item"
              :class="{ active: item.active }"
              v-for="(item, index) in nav_list"
              :key="item.id"
              v-show="item.id"
              @click="changeActive(index)">
              {{ item.name }}
            </div>
            <div class="item" style="color: var(--Btn-brc);op" @click="toggleCreateDialog">
              编辑自选组合
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    nav_list: Array,
  },
  data() {
    return {
      activeNames: '自选组合',
    };
  },
  computed: {
    subHasActive() {
      return this.nav_list.some((item) => item.active);
    },
  },
  mounted() {},
  methods: {
    toggleCreateDialog() {
      this.$emit('toggleCreateDialog');
    },
    changeActive(index) {
      if (index !== undefined) {
        this.$emit(
          'update:nav_list',
          this.nav_list.map((item, i) => ({
            ...item,
            active: i === index,
          }))
        );
      } else {
        this.$emit(
          'update:nav_list',
          this.nav_list.map((item, i) => ({
            ...item,
            active: false,
          }))
        );
      }
    },
  },
};
</script>

<style scoped lang="less">
.line {
  width: 100%;
  margin: 16px 0;
  border-bottom: 1px dashed var(--el-header-text-color);
  opacity: 0.2;
}

.left-content {
  font-size: calc(var(--ROOTFONTFIZE) * (15 / 144));
  .title {
    padding-top: 20px;
    color: var(--el-header-text-color);
  }
  .item {
    // display: flex;
    // align-items: center;
    height: calc(var(--ROOTFONTFIZE) * (48 / 144));
    line-height: calc(var(--ROOTFONTFIZE) * (28 / 144));
    box-sizing: border-box;
    cursor: pointer;
    padding: calc(var(--ROOTFONTFIZE) * (10 / 144));
    font-size: calc(var(--ROOTFONTFIZE) * (15 / 144));
    color: var(--el-header-text-color);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
    &.active {
      cursor: default;
      color: var(--primary-color);
      &.item-1 {
        background-color: var(--el-menuitem-active-bgc) !important;
        color: var(--el-menuitem-active-color) !important;
      }
    }
  }
  .el-cols-wrap {
    margin-top: 10px;
    /deep/.el-collapse {
      border: none;
    }
    /deep/.el-collapse-item__header {
      height: calc(var(--ROOTFONTFIZE) * (40 / 144));
      padding: 0 calc(var(--ROOTFONTFIZE) * (10 / 144));
      border: none;
      font-size: calc(var(--ROOTFONTFIZE) * (15 / 144));
      color: var(--el-header-text-color);
      background-color: transparent;
    }
    /deep/.el-collapse-item__wrap {
      border: none;
      background-color: transparent;
    }
    /deep/.item {
      .item();
      padding-left: 20px;
      padding-right: 0;
    }
    &.active {
      /deep/.el-collapse-item__header {
        background-color: var(--el-menuitem-active-bgc) !important;
        color: var(--el-menuitem-active-color) !important;
      }
    }
  }
}
</style>
